<template>
  <div class="fixed bottom-0 left-0 right-0 container">
        <div class="p-6 bg-g300 rounded-t-3xl flex justify-between items-center">
         <router-link to="/" class="flex flex-col gap-1 justify-center items-center">
            <i class="ph-fill ph-house text-3xl !leading-none text-o300"></i>
            <p class="text-xs font-semibold text-white">Home</p>
         </router-link> 
           
          <router-link to="/admin" class="flex flex-col gap-1 justify-center items-center">
            <i class="ph ph-lock text-3xl !leading-none text-white"></i>
            <p class="text-xs font-semibold text-white">Admin</p>
           </router-link> 
          <a href="#" class="flex justify-center items-center p-3.5 bg-o300 rounded-full">
            <i class="ph ph-barcode text-2xl !leading-none text-n0"></i>
          </a>
          <a href="#" class="flex flex-col gap-1 justify-center items-center">
            <i class="ph ph-chart-line-up text-3xl !leading-none text-white"></i>
            <p class="text-xs font-semibold text-white">Insights</p>
          </a>
          <a href="#" class="flex flex-col gap-1 justify-center items-center" @click="logout()">
            <i class="ph ph-sign-out text-3xl !leading-none text-white"></i>
            <p class="text-xs font-semibold text-white">Logout</p>
          </a>
        </div>
      </div>

</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

function logout(){
 localStorage.removeItem("token");
 localStorage.removeItem("user");
  router.push("/login");

}

</script>
<script>
export default {
  name: 'NavAdmin',
  
}
</script>